import(/* webpackMode: "eager", webpackExports: ["AwardsRecognition"] */ "/root/bitsshadow.com/bitsshadow-fe/components/awards/AwardsRecognition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/career/CompleteStaffAugmentation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/career/FlexibleEngagementModels.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/career/ServiceGridRow.tsx");
;
import(/* webpackMode: "eager" */ "/root/bitsshadow.com/bitsshadow-fe/components/career/SmartSolution.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/career/StaffAugmentationCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/career/WhyChooseStaffAugmentation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/Image-and-summary/ImageAndSummary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndustryExpertise"] */ "/root/bitsshadow.com/bitsshadow-fe/components/industry-expertise/IndustryExpertise.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioItem"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/PortfolioCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioHero"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/PortfolioHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectContactCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectDetails"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectNext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectOverview"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectProblem"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectProblem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectResult"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectResult.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectSolution"] */ "/root/bitsshadow.com/bitsshadow-fe/components/portfolio/ProjectSolution.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bitsshadow.com/bitsshadow-fe/components/questions/Questions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentWorks"] */ "/root/bitsshadow.com/bitsshadow-fe/components/recent-works/RecentWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppTools"] */ "/root/bitsshadow.com/bitsshadow-fe/components/scrolling-apps-tools/AppTools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Services"] */ "/root/bitsshadow.com/bitsshadow-fe/components/services/Services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SoftwareService"] */ "/root/bitsshadow.com/bitsshadow-fe/components/software-service/SoftwareService.tsx");
;
import(/* webpackMode: "eager" */ "/root/bitsshadow.com/bitsshadow-fe/node_modules/next/dist/client/image-component.js");
